import { Breadcrumb } from '../../types';

export const systemBreadcrumbs: Map<string, Breadcrumb> = new Map([
	[
		'auditLogList',
		{
			name: 'Audit Log List',
			to: '/system/audit-logs',
			i18nKey: 'breadcrumb.auditLogs',
		},
	],
	[
		'auditLogDetails',
		{
			name: 'View Audit Log',
			i18nKey: 'breadcrumb.auditLogDetails',
		},
	],
]);
